const validations = [
  { required: true, message: 'Phone number is required' },
  {
    validator: (_: unknown, value: string) => {
      if (value?.length < 12) {
        return Promise.reject('Enter a valid phone number');
      }

      return Promise.resolve();
    },
  },
];

export default validations;
